<template>
    <div class="modal_block">
        <div class="title">
            <span> {{ question }} </span>
        </div>
        <div class="">
            <div class="line">
                <div class="reason">
                    <label>
                        {{ !status ? translate('device.reason_for_blocking') : translate('device.reason_for_unblocking') }}
                    </label>
                    <textarea
                        v-model="reason"
                        rows="3"
                        class="form-control border-input"
                        :placeholder="translate('device.reason_for_blocking')"
                    />
                </div>
            </div>

            <div  v-if="status===1">
                <label>
                    {{ translate('date.scheduled_time') }}
                </label>

                <div class="line">
                    <span class="flex-item tracking-date-range" >
                      <WrapDatePicker
                          v-model="date"
                          type="datetime"
                          :range="false"
                          value_type="X"
                          :disabled_date="['now', '+ 1 month']"
                          :placeholder="translate('date.one')"
                      />
                    </span>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button class="btn btn-info btn-fill btn-wd marginButton" @click.prevent="setBlockedDevice">
                {{ translate('yes') }}
            </button>

            <button class="btn btn-danger btn-fill btn-wd marginButton" @click.prevent="cancel">
                {{ translate('no') }}
            </button>
        </div>
    </div>

</template>

<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
    name: "BlockDevice",
  components: {WrapDatePicker},
    props: ['fid', 'question', 'status'],

    data () {
        return {
            reason: '',
            date: null,
            time: null
        }
    },
    methods: {
        setBlockedDevice(){
            let new_status = (this.status === 1) ? 0 : 1
            let params = {
                new_status: new_status,
                reason: this.reason,
                ts_scheduled: this.date ? Number(this.date) : 0
            }

            this.$http.v1.setDeviceBlockStatus(this.fid, params,() => {
                this.global_notify('info', new_status === 1 ? this.translate('device.blocked_device') : this.translate('device.unblocked_device'))
                this.$store.dispatch('updateDeviceProfile', this.fid)
                this.$emit('close')
            })
        },
        cancel () {
          this.$emit('close')
        },
    }
}
</script>

<style lang='scss' scoped>
.modal_block{
    padding: 10px;
    .title{
        text-align: center;
    }
    .line{
        width: 100%;
        display: flex;
        align-content: center;
        justify-content: space-between;
        .reason{
            width: 100%;
            margin-bottom: 10px;
        }
        .tracking-date-range{
          width: 100%;
          margin-bottom: 10px;
        }
    }


}

</style>
